import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64653832"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timetable-results" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = {
  key: 0,
  class: "loading"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 2,
  class: "timetable-results__list"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "price"
}
const _hoisted_11 = {
  key: 3,
  class: "price"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSvg = _resolveComponent("BaseSvg")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.departures)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          (_ctx.title)
            ? (_openBlock(), _createElementBlock("header", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.title), 1),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.params.icons, (icon) => {
                      return (_openBlock(), _createBlock(_component_BaseSvg, {
                        key: icon,
                        icon: icon
                      }, null, 8, ["icon"]))
                    }), 128))
                  ]),
                  _createElementVNode("li", null, _toDisplayString(_ctx.params.modeOfTravel) + " >", 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.params.leavingFrom) + " >", 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.params.goingTo), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_BaseSpinner, { size: 40 })
                  ]))
                : (_ctx.departures.length < 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_BaseAlert, {
                        type: "info",
                        message: "No departures found"
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departures, (departure) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: `${departure.date}|${departure.start}|${departure.end}`
                        }, [
                          _createElementVNode("span", null, _toDisplayString(departure.date), 1),
                          _createElementVNode("span", null, _toDisplayString(departure.start) + " > " + _toDisplayString(departure.end), 1),
                          (departure.price && !departure.locked && departure.seatsLeft < 5 && departure.seatsLeft > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Only " + _toDisplayString(departure.seatsLeft) + " seats available", 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_9)),
                          (departure.price && departure.seatsLeft && !departure.locked)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                (_ctx.year(departure.departureDate) <= 2024)
                                  ? (_openBlock(), _createBlock(_component_BaseButton, {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.goToBookingFlow(departure))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("span", null, "Book now from £" + _toDisplayString(departure.price.toFixed(2)), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : (_openBlock(), _createBlock(_component_BaseButton, {
                                      key: 1,
                                      onClick: ($event: any) => (_ctx.goToBookingFlow(departure))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("span", null, "£" + _toDisplayString(departure.price.toFixed(2)), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_11, " Fully booked "))
                        ]))
                      }), 128))
                    ]))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}